var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M9.174 10.116H5.406a.942.942 0 01-.942-.942V5.406c0-.52.422-.942.942-.942h3.768c.52 0 .942.422.942.942v3.768c0 .52-.422.942-.942.942zm9.42 0h-3.768a.942.942 0 01-.942-.942V5.406c0-.52.422-.942.942-.942h3.768c.52 0 .942.422.942.942v3.768c0 .52-.422.942-.942.942zm-9.42 9.42H5.406a.942.942 0 01-.942-.942v-3.768c0-.52.422-.942.942-.942h3.768c.52 0 .942.422.942.942v3.768c0 .52-.422.942-.942.942zm9.42 0h-3.768a.942.942 0 01-.942-.942v-3.768c0-.52.422-.942.942-.942h3.768c.52 0 .942.422.942.942v3.768c0 .52-.422.942-.942.942z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel);
export default __webpack_public_path__ + "static/media/pixel.89b07adaf65dd96c8fef28e4ed66eb5c.svg";
export { ForwardRef as ReactComponent };